<script setup>
import Delimiter from '@sections/delimiter.vue'
import ContactSection from '@sections/home-page/contact.vue'
</script>
<template>
	<ContactSection />
	<Delimiter />
</template>
